__turbopack_context__.v({
  "bounce": "LoadingCards-module-scss-module__VK0Jua__bounce",
  "consumerEventLoadingCard": "LoadingCards-module-scss-module__VK0Jua__consumerEventLoadingCard",
  "consumerEventLoadingCardAside": "LoadingCards-module-scss-module__VK0Jua__consumerEventLoadingCardAside",
  "consumerEventLoadingCardItem": "LoadingCards-module-scss-module__VK0Jua__consumerEventLoadingCardItem",
  "consumerEventLoadingCardMain": "LoadingCards-module-scss-module__VK0Jua__consumerEventLoadingCardMain",
  "consumerLoadingCardsGrid": "LoadingCards-module-scss-module__VK0Jua__consumerLoadingCardsGrid",
  "consumerLoadingCardsList": "LoadingCards-module-scss-module__VK0Jua__consumerLoadingCardsList",
  "consumerLoadingCardsListFlipped": "LoadingCards-module-scss-module__VK0Jua__consumerLoadingCardsListFlipped",
  "consumerLoadingCardsListResponsive": "LoadingCards-module-scss-module__VK0Jua__consumerLoadingCardsListResponsive",
  "consumerLoadingCardsListResponsiveFlipped": "LoadingCards-module-scss-module__VK0Jua__consumerLoadingCardsListResponsiveFlipped",
  "consumerLoadingCardsListSquare": "LoadingCards-module-scss-module__VK0Jua__consumerLoadingCardsListSquare",
  "consumerLoadingCardsListSquareFlipped": "LoadingCards-module-scss-module__VK0Jua__consumerLoadingCardsListSquareFlipped",
  "depress": "LoadingCards-module-scss-module__VK0Jua__depress",
  "elevate": "LoadingCards-module-scss-module__VK0Jua__elevate",
  "fadeIn": "LoadingCards-module-scss-module__VK0Jua__fadeIn",
  "fadeInDown": "LoadingCards-module-scss-module__VK0Jua__fadeInDown",
  "fadeInLeft": "LoadingCards-module-scss-module__VK0Jua__fadeInLeft",
  "fadeInRight": "LoadingCards-module-scss-module__VK0Jua__fadeInRight",
  "fadeInUp": "LoadingCards-module-scss-module__VK0Jua__fadeInUp",
  "fadeOut": "LoadingCards-module-scss-module__VK0Jua__fadeOut",
  "fadeOutDown": "LoadingCards-module-scss-module__VK0Jua__fadeOutDown",
  "fadeOutUp": "LoadingCards-module-scss-module__VK0Jua__fadeOutUp",
  "grow": "LoadingCards-module-scss-module__VK0Jua__grow",
  "loadingCardSwipeX": "LoadingCards-module-scss-module__VK0Jua__loadingCardSwipeX",
  "loadingCardSwipeY": "LoadingCards-module-scss-module__VK0Jua__loadingCardSwipeY",
  "moveIn": "LoadingCards-module-scss-module__VK0Jua__moveIn",
  "moveOut": "LoadingCards-module-scss-module__VK0Jua__moveOut",
  "pop": "LoadingCards-module-scss-module__VK0Jua__pop",
  "root": "LoadingCards-module-scss-module__VK0Jua__root",
  "rotate": "LoadingCards-module-scss-module__VK0Jua__rotate",
  "rotateX": "LoadingCards-module-scss-module__VK0Jua__rotateX",
  "rotateY": "LoadingCards-module-scss-module__VK0Jua__rotateY",
  "shake": "LoadingCards-module-scss-module__VK0Jua__shake",
  "shorten": "LoadingCards-module-scss-module__VK0Jua__shorten",
  "slideUp": "LoadingCards-module-scss-module__VK0Jua__slideUp",
});
